<!--1-->
<template>
  <div class="topBar-css">
    <div class="avatar">
<!--      <span class="avatar-icon" @click="routerChange(1)"><img src="../assets/Vector2.png" alt="" /></span>-->
<!--      <span class="avatar-icon" @click="routerChange(2)"><img src="../assets/Vector.png" alt="" /></span>-->
      <div class="avatar-img">
        <img class="avatar-img" :src="urlImgInfo" @error="e=>{
         e.target.src = require('@/assets/avatar.png')
    }" alt="" />
      </div>
      <span>{{ item.userName }}</span>
    </div>
    <button class="topBar-button">{{ $t("homepost") }}</button>
    <button class="topBar-button" @click="goToLogout">{{ $t("logout") }}</button>
  </div>
</template>
<script>
import AES from "../js/AES"
import { getUrlFromOSS } from "../js/api"
export default {
  name: "topBar",
  components: {},
  data() {
    return {
      item: {},
      urlImgInfo: ""
    };
  },
  created() {

  },
  watch: {
    '$route.path': {
      handler(toPath, fromPath) {
        var userInfo = localStorage.getItem("userInfo")
        const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
        console.log("---------------userInfo---------------")
        console.log(aesFecInfo)
        this.item = aesFecInfo
        this.getUrl()
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    }
  },
  computed: {},
  methods: {
    // 头像回显
    getUrl() {
      var fakeInfo = {
        message: this.item.avatar
      }
      getUrlFromOSS(fakeInfo).then((res) => {
        console.log("-----------头像回显-----------")
        if (res.data.code === '200 OK') {
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo)
          this.urlImgInfo = aesFecInfo.message
        }
        console.log(res)
      }).catch((res) => {
        console.log("-----------头像回显-----------")
        console.log(res)
      })
    },
    //路由跳转
    routerChange(item) {
      console.log(item)
      console.log(this.item)
      if (this.item.medicalId !== "" && this.item.educationId === "") {
        this.$router.push({
          path: "/medicalInstitutionNewsView",
          query: { itemNum: item },
        });
      } else if (this.item.educationId !== "" && this.item.medicalId === "") {
        this.$router.push({
          path: "/educationInstitutionNewsView",
          query: { itemNum: item },
        });
      } else if (this.item.medicalId === "" && this.item.educationId === "") {
        if (this.item.roleName === "educationalinstitutionadmin" || this.item.roleName === "educationalinstitutionuser") {
          this.$router.push({
            path: "/educationalCertificationAdd",
            query: { itemNum: item },
          });
        } else if (this.item.roleName === "medicalinstitutionuser" || this.item.roleName === "medicalinstitutionadmin") {
          this.$router.push({
            path: "/advancedCertification",
            query: { itemNum: item },
          });
        }
      }
    },
    //退出登录清除token跳转 未登录首页
    goToLogout() {
      if (this.item.roleName === "adminuser") {
        localStorage.removeItem('token');
        this.$router.push("/loginAdmin");
      } else {
        localStorage.removeItem('token');
        this.$router.push("/");
      }
    },
  },
};
</script>
<style scoped>
.topBar-css {
  width: 95%;
  margin-left: 2.5%;
  background: #fff;
  height: 60px;
  border-bottom: 1px solid #e0e1ea;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: right;
}

.topBar-button {
  float: right;
  width: 100px;
  height: 30px;
  line-height: 30px;
  background: #51abff;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  box-sizing: border-box;
  margin-left: 20px;
  cursor: pointer;
}

.avatar {
  margin-left: 20px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #686868;
  display: flex;
}

.avatar-img {
  width: 28px;
  height: 28px;
  text-align: center;
  border-radius: 50%;
  margin-right: 10px;
  overflow: hidden;
}

.avatar-icon {
  margin-right: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue